import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type BlenderAddonDownloadQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BlenderAddonDownloadQuery = { __typename: 'Query', blenderAddonDownload?: { __typename: 'BlenderAddonDownload', version: string, url: string, fileName: string } | null };

export const BlenderAddonDownloadDocument = gql`
    query blenderAddonDownload {
  blenderAddonDownload {
    version
    url
    fileName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BlenderAddonDownloadGQL extends Apollo.Query<BlenderAddonDownloadQuery, BlenderAddonDownloadQueryVariables> {
    override document = BlenderAddonDownloadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }